import { FormControl, FormControlLabel, FormHelperText, Grid } from '@material-ui/core';
import { FormikErrors, FormikHandlers, FormikHelpers, getIn } from 'formik';
import React from 'react';
import Label from '../../../../common/components/label';
import { ISi } from '../../../../common/dtos/SiDto';
import { BreakReasonCodes_class } from '../../../../common/enums/BreakReasonCodes';
import { IndentGrid, MHARadio } from '../../../../common/styles/styles';

interface Props {
  label: string;
  name: string;
  value: number | undefined;
  errors: FormikErrors<ISi>;
  handleBlur: FormikHandlers["handleBlur"];
  setFieldValue: FormikHelpers<ISi>["setFieldValue"];
  isReadOnly: boolean;
}

const BreakReasonCodeField: React.FC<Props> = ({ label, name, value, errors, handleBlur, setFieldValue, isReadOnly }) => {

  return (
    <>
      <Grid item xs={12}>
        <Label>{label}</Label>
      </Grid>
      <IndentGrid container direction="row">
        <FormControl error={Boolean(getIn(errors, name))} >
          <IndentGrid container direction="row">
            <FormControlLabel
              checked={value === BreakReasonCodes_class.enum.Item1}
              value={value}
              data-cy={`sidesResponse_${name}_Item1`}
              onChange={() => setFieldValue(name, BreakReasonCodes_class.enum.Item1)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} size="small" name={name} />}
              label="Customary break/Holiday" />
            <FormControlLabel
              checked={value === BreakReasonCodes_class.enum.Item2}
              value={value}
              data-cy={`sidesResponse_${name}_Item2`}
              onChange={() => setFieldValue(name, BreakReasonCodes_class.enum.Item2)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} name={name} size="small" />}
              label="Between academic years" />
            {/*<FormControlLabel*/}
            {/*  checked={value === undefined}*/}
            {/*  value={value}*/}
            {/*  data-cy={`sidesResponse_${name}_undefined`}*/}
            {/*  onChange={() => setFieldValue(name, undefined)}*/}
            {/*  onBlur={handleBlur}*/}
            {/*  control={<MHARadio disabled={isReadOnly} name={name} size="small" />}*/}
            {/*  label="N/A" />*/}
          </IndentGrid>
          {Boolean(getIn(errors, name)) &&
            <FormHelperText
            id={`${name}-helper_text`}
          >
              {getIn(errors, name)}
            </FormHelperText>
          }
        </FormControl>
      </IndentGrid>
    </>
  );

}

export default BreakReasonCodeField;